import { pointsOptions } from "../../constants";
let formatCallback;
export const buildPointsFormatter = (pointsFormatter, overrideOptions) => {
    const options = Object.assign(Object.assign({}, pointsOptions), {} //Left for override
    );
    if (!formatCallback || overrideOptions) {
        formatCallback = formatter.bind(undefined, pointsFormatter(options));
    }
    return formatCallback;
};
const formatter = (formatter, value) => {
    if (typeof value !== "number") {
        value = parseFloat(value);
    }
    return formatter.format(value);
};
//# sourceMappingURL=buildPointsFormatter.js.map